import React from "react";
import {profileImageUrl, ventureImageUrl} from "../../../helpers/urls";

const VentureOptionLabel = (venture) =>
    <span><img className="user__img" src={ventureImageUrl(venture)} /> {venture.name} </span>;

export default VentureOptionLabel;
